/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var Custom = {
    Cart: {
        init: function () {
            $('[data-frame-options]').on('change', function (evt) {
                var selectEl = evt.target;
                var value = selectEl.value;
                var el = $('[data-frame-options] option:selected');
                if (value === "remove") {
                    this.removeFrame(el[0], true);
                    return;
                }
                var currentId = selectEl.getAttribute('data-frame-id');
                if (currentId) {
                    return this.removeFrame(selectEl).then(function () {
                        this.addFrame(el[0], true);
                    }.bind(this));
                }
                this.addFrame(el[0], true);
            }.bind(this));
        },

        removeFrame: function (el, reload) {
            var url = el.getAttribute('data-frame-href');
            var frameId = el.getAttribute('data-frame-id');

            return new Promise(function (r) {
                $.get(url).then(function () {
                    $.ajax({
                        url: '/cart/change.js',
                        dataType: 'json',
                        data: {
                            id: frameId,
                            quantity: 0,
                            frame: true,
                        }
                    }).then(function () {
                        if (reload) {
                            window.location.reload();
                        } else {
                            r();
                        }
                    });
                })
            });
        },

        addFrame: function (el, reload) {
            var url = el.getAttribute('data-frame-href');
            var variantId = el.getAttribute('data-variant-id');
            var hashId = el.getAttribute('data-hash-id');

            return new Promise(function (r) {
                $.get(url).then(function () {
                    console.log(variantId, hashId);
                    $.ajax({
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: {
                            id: variantId,
                            quantity: 1,
                            properties: {
                                code: hashId,
                                frame: true,
                            }
                        }
                    }).then(function () {
                        if (reload) {
                            window.location.reload();
                        } else {
                            r();
                        }
                    });
                })
            });
        },
    },

    init: function () {
        if ($('[data-section-type="cart-template"]').length) {
            this.Cart.init();
        }
    }
};

Custom.init();
